/**
 * Componente de gráfico de pedidos enviados por período
 * Orders sent by period chart component
 */
import { SectionBox } from '@shared/components/ui/SectionBox';
import { Tabs, TabsList, TabsTrigger } from '@shared/components/ui/shadcn/tabs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OrdersPeriodMetrics } from './OrdersPeriodMetrics';
import { OrdersPeriodLineChart } from './OrdersPeriodLineChart';
import { GlobalMetrics, DailyMetric } from '../../models/LogisticsApiResponse';

export type PeriodTab = 'all' | 'sent' | 'delivered' | 'in_transit' | 'returned';

interface OrdersByPeriodChartProps {
  globalMetrics?: GlobalMetrics;
  dailyMetrics?: DailyMetric[];
  isLoading?: boolean;
}

export const OrdersByPeriodChart = ({ globalMetrics, dailyMetrics, isLoading = false }: OrdersByPeriodChartProps) => {
  const { t } = useTranslation('logisticsModule');
  const [activeTab, setActiveTab] = useState<PeriodTab>('all');

  return (
    <SectionBox className="space-y-0" data-testid="orders-by-period-chart">
      {/* Título - Title */}
      <h2 className="text-lg font-semibold text-title mb-4">{t('orders_by_period.title')}</h2>

      {/* Tabs - Pestañas */}
      <div className="mb-4 overflow-x-auto">
        <Tabs value={activeTab} onValueChange={(value) => setActiveTab(value as PeriodTab)}>
          <TabsList className="flex w-full lg:grid lg:grid-cols-5 border-0 bg-card-bg min-w-max lg:min-w-0 gap-2">
            <TabsTrigger value="all" data-testid="tab-all" className="whitespace-nowrap flex-shrink-0">
              {t('orders_by_period.tabs.all')}
            </TabsTrigger>
            <TabsTrigger value="sent" data-testid="tab-sent" className="whitespace-nowrap flex-shrink-0">
              {t('orders_by_period.tabs.sent')}
            </TabsTrigger>
            <TabsTrigger value="delivered" data-testid="tab-delivered" className="whitespace-nowrap flex-shrink-0">
              {t('orders_by_period.tabs.delivered')}
            </TabsTrigger>
            <TabsTrigger value="in_transit" data-testid="tab-in-transit" className="whitespace-nowrap flex-shrink-0">
              {t('orders_by_period.tabs.in_transit')}
            </TabsTrigger>
            <TabsTrigger value="returned" data-testid="tab-returned" className="whitespace-nowrap flex-shrink-0">
              {t('orders_by_period.tabs.returned')}
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>

      {/* Métricas - Metrics */}
      <div className="mb-4">
        <OrdersPeriodMetrics
          activeTab={activeTab}
          globalMetrics={globalMetrics}
          dailyMetrics={dailyMetrics}
          isLoading={isLoading}
        />
      </div>

      {/* Gráfico de línea - Line chart */}
      <OrdersPeriodLineChart activeTab={activeTab} dailyMetrics={dailyMetrics} />
    </SectionBox>
  );
};
